import GeneratorLaber from "./GeneratorLabel";
export default GeneratorLaber;
